import { Stack, Typography } from '@mui/material';
import { PossibleSibling } from '@schooly/api';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import EmptyStub from '../../../components/common/ProfileModal/EmptyStub';
import { Counter } from '../../../components/uikit/Counter/Counter.styled';
import { ProfileModalMode } from '../../../context/profile/helpers';
import { useProfile } from '../../../context/profile/useProfile';
import ProfileCard from '../ProfileCard';

// This component only renders for userType 'adult' | 'parent' (see ProfileModalSchoolContext).
// The edit-children feature (EditChildrenModal, ChildrenExternalSidebar, useChildrenEdit)
// was unreachable: showEditButton was always false for these types. Dead chain removed.

export const ProfileModalChildren: FC = () => {
  const { user, userType } = useProfile();

  if (!user || !userType) {
    return <EmptyStub mode={ProfileModalMode.Family} />;
  }

  const { adult_associations } = user as unknown as { adult_associations: PossibleSibling[] };

  if (!adult_associations?.length) {
    return <EmptyStub mode={ProfileModalMode.Family} />;
  }

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2.5}>
        <Stack direction="row" alignItems="center">
          <Typography variant="h2">
            <FormattedMessage id="section-Family" />
          </Typography>
          {!!adult_associations.length && <Counter>{adult_associations.length}</Counter>}
        </Stack>
      </Stack>

      <Typography variant="h4">
        <FormattedMessage id="userType-child-plural" />
      </Typography>

      <div className="cards-wrapper">
        {adult_associations.map((item) => (
          <ProfileCard
            key={item.user_id}
            user={
              !!item.school_user_relation && !!Object.keys(item.school_user_relation).length
                ? item.school_user_relation
                : item
            }
            userType={
              !!item.school_user_relation && !!Object.keys(item.school_user_relation).length
                ? 'student'
                : 'child'
            }
          />
        ))}
      </div>
    </>
  );
};
